/**
 * Banner管理相关API接口
 */
import axios from '../axios'

const bannerAPI = {
  // Banner相关接口
  // 获取Banner列表
  getBannerList(params) {
    return axios({
      url: '/banners',
      method: 'GET',
      params
    })
  },
  
  // 获取单个Banner详情
  getBanner(id) {
    return axios({
      url: `/banners/${id}`,
      method: 'GET'
    })
  },
  
  // 创建Banner
  createBanner(data) {
    return axios({
      url: '/banners',
      method: 'POST',
      data
    })
  },
  
  // 更新Banner
  updateBanner(data) {
    return axios({
      url: `/banners/${data.id}`,
      method: 'PUT',
      data
    })
  },
  
  // 删除Banner
  deleteBanner(id) {
    return axios({
      url: `/banners/${id}`,
      method: 'DELETE'
    })
  }
}

export default bannerAPI